import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import classNames from "classnames";
import { CloseButton } from "../../../../components/CloseButton";
import { DEPRECATED_TextInput } from "../../../../components/DEPRECATED_TextInput";
import { Loading } from "../../../../components/Loading";
import { useDynamicScript } from "../../../../hooks/useDynamicScript";
import { useOutsideClick } from "../../../../hooks/useOutsideClick";
import { useConfig } from "../../../../providers/useConfig";
import styles from "./DaumPlaceInput.module.scss";
const prepareDaumAutocompleteResults = (data) => {
    const city = data.sigungu || data.bname1 || data.sido || "";
    const streetName = data.address || data.roadname || data.roadAddress;
    return {
        streetName,
        streetNumber: "",
        postcode: data.zonecode,
        city,
        provinceName: data.sido || "",
        districtName: data.bname || "",
    };
};
const MAX_MOBILE_WIDTH = 479;
export const DaumPlaceInput = forwardRef(({ onPlace, ...props }, ref) => {
    const [widget, setWidget] = useState();
    const [isWidgetOpened, setWidgetOpened] = useState(false);
    const { autocompleteProviderExternalJs } = useConfig();
    const { isScriptLoaded, isScriptLoading } = useDynamicScript(autocompleteProviderExternalJs);
    const widgetContainerRef = useRef(null);
    const isMobile = useMediaQuery({ maxWidth: MAX_MOBILE_WIDTH });
    const closeWidget = () => {
        setWidgetOpened(false);
    };
    useOutsideClick(widgetContainerRef, () => {
        closeWidget();
    });
    const openWidget = () => {
        setWidgetOpened(true);
        widget.embed(widgetContainerRef.current);
    };
    useEffect(() => {
        if (!isScriptLoaded || !window.daum) {
            return;
        }
        setWidget(new window.daum.Postcode({
            width: isMobile ? "100%" : "",
            height: isMobile ? "100%" : "",
            oncomplete: (data) => {
                onPlace(prepareDaumAutocompleteResults(data));
                closeWidget();
            },
        }));
    }, [onPlace, isScriptLoaded]);
    if (isScriptLoading) {
        return _jsx(Loading, {});
    }
    return (_jsxs("div", { className: styles.daumAutocompleteContainer, children: [_jsx(DEPRECATED_TextInput, { className: styles.daumAutocompleteWidgetInput, onClick: openWidget, readOnly: true, ...props, ref: ref }), _jsx("div", { className: classNames(styles.daumAutocompleteWidgetContainer, {
                    [styles.daumAutocompleteWidgetInactive]: !isWidgetOpened,
                }), ref: widgetContainerRef, children: _jsx(CloseButton, { dataTestId: "closeButton", onClick: closeWidget, className: classNames(styles.mobileWidgetCloseIcon) }) })] }));
});
//# sourceMappingURL=DaumPlaceInput.js.map